import React from "react";
import CDNVideo from "./CDNVideo";
import { cdnUrlBase } from "../constants/config";
import projects from "../constants/projects";

const ProjectImage = ({ title, path }) => (
  <img alt={title} title={title} src={`${cdnUrlBase}/${path}`} />
);

function makeLinkLine(project) {
  const { repoURL, liveSiteURL } = project;
  const links = [];
  if (repoURL) {
    links.push(<a key="repo" target="_blank" href={repoURL}>GitHub</a>);
  }
  if (liveSiteURL) {
    links.push(<a key="live-site" target="_blank" href={liveSiteURL}>Live Site</a>);
  }
  return links.length > 0 ? <h3>{links}</h3> : null;
}

export default ({
  match: {
    params: { project }
  }
}) => {
  const { title, platformComponents, description, media } = projects[project];

  return (
    <main className="project">
      <header>
        <h1>{title}</h1>
        <h2>
          {platformComponents.reduce((prev, curr, i) => [
            prev,
            <span key={i}> &#8258; </span>,
            curr
          ])}
        </h2>
        {makeLinkLine(projects[project])}
        <div className="project-description">
          {description}
        </div>
      </header>
      {media.map(media => (
        <section key={media.title}>
          <div className="content">
            <div className="media">
              {media.type === "video" ? (
                <CDNVideo filePath={media.path} />
              ) : (
                <ProjectImage {...media} />
              )}
            </div>
            <div className="description">
              <h1>{media.title}</h1>
              <p>{media.description}</p>
            </div>
          </div>
        </section>
      ))}
    </main>
  );
};



// WEBPACK FOOTER //
// ./src/components/Project.js